import angular  from 'angular'
import uiRouter from 'angular-ui-router'
import 'angular-carousel'
import 'angular-touch'
import 'angular-carousel/dist/angular-carousel.css'

import component from './home-slider.component'

let module = angular.module('homeSlider', [
  uiRouter,
  'angular-carousel'
])

.component('homeSlider', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/home/slider/index.js